import React from 'react';
import { Row, Col, Tree } from 'antd';
import { Link } from 'react-router-dom';
import { InferenceFile } from '../types';
import { MultiflowIteratorResult, MultiflowIteratorLevel } from '../types/flow';
import { DownOutlined } from '@ant-design/icons';
import { Section } from './Section';
import { SectionTitle } from './text/Titles';

type Props = {
  inferenceFile: null | InferenceFile;
  multiIteratorResult: MultiflowIteratorResult | null;
};

export const FlowPath = ({ inferenceFile, multiIteratorResult }: Props) => {
  const generateTreeData = (iteratorHistory: MultiflowIteratorLevel[]) => {
    const treeData: any[] = [];
    var currenNode = treeData;
    for (var i = 0; i < iteratorHistory.length; i += 1) {
      const newNode = {
        title: `${iteratorHistory[i].name} ${
          iteratorHistory[i].trigger_value !== 'default' ? `Triggered by ${iteratorHistory[i].trigger_value}` : ''
        }`,
        key: i,
        children: [],
        isLeaf: false,
      };
      currenNode.push(newNode);
      currenNode = newNode.children;
    }
    return treeData;
  };

  return (
    <>
      <Section>
        <Row className="w-full">
          <Col>
            <SectionTitle>Flow path</SectionTitle>
          </Col>
        </Row>
        <Row className="w-full items-center">
          <Col span={12}>
            {multiIteratorResult ? (
              <Tree
                switcherIcon={<DownOutlined />}
                showIcon={false}
                showLine={true}
                treeData={generateTreeData(multiIteratorResult.history)}
              />
            ) : (
              <span>No flow path found</span>
            )}
          </Col>
          <Col span={12} className="flex justify-end">
            {inferenceFile && (
              <Link
                className="ant-btn ant-btn-secondary ant-btn-md mr-4"
                to={{ pathname: inferenceFile.presignedUrl }}
                target="_blank"
                download>
                Download Pdf
              </Link>
            )}
          </Col>
        </Row>
      </Section>
    </>
  );
};
